/**
 * Server configuration utilities
 */

/**
 * Get the server URL from environment variables
 * @returns The base server URL without '/api' suffix
 * @throws Error if no environment variable is set
 */
export const getServerUrl = (): string => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;

    if (!baseUrl) {
        throw new Error('VITE_API_BASE_URL environment variable is not set');
    }

    // Remove '/api' suffix if present to get the base server URL
    return baseUrl.replace(/\/api$/, '');
};

/**
 * Get the API base URL from environment variables
 * @returns The API base URL with '/api' suffix
 * @throws Error if no environment variable is set
 */
export const getApiBaseUrl = (): string => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;

    if (!baseUrl) {
        throw new Error('VITE_API_BASE_URL environment variable is not set');
    }

    return baseUrl;
};